import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

export default function DeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
  action='Delete',
  text = 'Are you sure you want to delete this item?',
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
        <Typography variant="h3">Confirm {action}</Typography>
        {true && ( // ToDo: !isSubmitting
          <IconButton edge="end" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <Divider />
      <DialogContent>{text}</DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
        >
          {action}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
